import React from "react";
import { makeStyles, Typography, Box, useTheme, useMediaQuery } from "@material-ui/core";

import { formatPriceCents, getModelType, isProductNew } from "./utils";
import AddToCart from "./AddToCart";
import Tag from "components/design-system/atoms/Tag";
import Reassurance from "./reassurance";

function ProductInformationHeader({ product, offline }) {
  const classes = useStyle();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <Box className={classes.informationHeader}>
      <Box display={!isMobile ? "flex" : ""} justifyContent={"space-between"}>
        <Box>
          <Typography variant="h2" component="div" className={classes.brandName}>
            {product.brand}
          </Typography>
          <Typography variant="h1" className={classes.title} color="textPrimary">
            {getModelType(product)}
          </Typography>
        </Box>
        {!offline && (
          <Box display={isMobile ? "flex" : ""} alignItems="center" className={classes.priceContainer}>
            <Typography variant="h1" className={classes.title} color="textPrimary">
              {formatPriceCents(product.price)}
            </Typography>
            {!isProductNew(product) && (
              <Box display="flex" className={classes.marketPriceContainer}>
                <Typography variant="body1" className={classes.marketPrice}>
                  {`${formatPriceCents(product.market_selling_price)} neuf`}
                </Typography>
                {product.discount && (
                  <Tag bgcolor="yellow">
                    <Box fontWeight={700} color="secondary.main">
                      {-product.discount}%
                    </Box>
                  </Tag>
                )}
              </Box>
            )}
          </Box>
        )}
      </Box>
      {!offline && (
        <>
          <AddToCart product={product} />
          <Box mt={5} mb={isMobile ? 5 : 3}>
            <Reassurance product={product} />
          </Box>
        </>
      )}
      {!product.available && !offline && (
        <Box color="secondary.dark" pt={1}>
          Trop tard ! Ce produit n&rsquo;est plus disponible :(
        </Box>
      )}
    </Box>
  );
}

const useStyle = makeStyles((theme) => ({
  brandName: {
    color: theme.palette.text.turquoise,
    fontSize: "34px",
    lineHeight: "120%",
    marginBottom: theme.spacing(1),
  },
  marketPriceContainer: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(3),
    },
  },
  title: {
    fontSize: 26,
    fontWeight: 500,
  },
  informationHeader: {
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(3),
    },
    marginBottom: theme.spacing(3),
  },
  priceContainer: {
    textAlign: "right",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(3),
      justifyContent: "space-between",
    },
  },
  button: {
    color: theme.palette.secondary.main,
  },
  marketPrice: {
    alignSelf: "center",
    textDecoration: "line-through",
    lineHeight: "1.2em",
    marginRight: theme.spacing(1),
    color: theme.palette.text.disabled,
  },
  discountItem: {
    display: "flex",
    alignItems: "flex-end",
    fontSize: 16,
    fontWeight: 500,
  },
}));

export default ProductInformationHeader;
